import { Injectable } from '@angular/core';

import { RESOURCE_ADJUSTMENT_ITEMS } from '../../../constants';

@Injectable({ providedIn: 'root' })
export class ConfigurePartyService {
  calculateCapacityInSelectedResources(resources = [], selectedResources = []) {
    const fullDataOfSelectedResources = resources.filter(resource => selectedResources.includes(resource._id));
    return this.calculateResourcesCapacity(fullDataOfSelectedResources);
  }

  calculateResourcesCapacity(resources = []) {
    return resources.reduce((acc, resource) => {
      acc.min += resource.capacity.min || 0;
      acc.max += resource.capacity.max || 0;
      return acc;
    }, { min: 0, max: 0 });
  }

  buildResourceSizeAlert(args: {
    actualSize: number;
    capacity: { min: number; max: number };
    customerLabel: string;
    resourceLabel: string;
    allowMultipleParties?: boolean;
    partySizeForTimeSlots?: boolean;
    overlappingParties?: { size?: number }[];
  }): string | null {
    const {
      actualSize,
      capacity,
      customerLabel,
      resourceLabel,
      allowMultipleParties,
      partySizeForTimeSlots,
      overlappingParties = [],
    } = args;

    if (!capacity || (capacity.min === 0 && capacity.max === 0)) {
      return null;
    }

    if (actualSize < capacity.min) {
      const delta = capacity.min - actualSize;
      return `Sorry, the ${customerLabel} size is below the ${resourceLabel} capacity by ${delta}. Please ${RESOURCE_ADJUSTMENT_ITEMS.remove} ${resourceLabel} or increase the ${customerLabel} size.`;
    }

    // How many spots the slot would hold with this party added.
    // - allowMultipleParties + count-by-parties: every party (any size) is 1 spot.
    // - allowMultipleParties + count-by-guests: each guest is a spot, so sum sizes.
    // - single-party mode: just this party's size against the resource max.
    let usedSpots: number;

    if (allowMultipleParties && !partySizeForTimeSlots) {
      usedSpots = overlappingParties.length + 1;
    } else if (allowMultipleParties) {
      usedSpots = overlappingParties.reduce((sum, party) =>
        sum + (party.size || 0), 0) + actualSize;
    } else {
      usedSpots = actualSize;
    }

    if (usedSpots > capacity.max) {
      const delta = usedSpots - capacity.max;
      return `Sorry, the ${customerLabel} size exceeds the ${resourceLabel} capacity by ${delta}. Please ${RESOURCE_ADJUSTMENT_ITEMS.add} ${resourceLabel} or reduce the ${customerLabel} size.`;
    }

    return null;
  }

  clean(obj) {
    for (const propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined) {
        delete obj[propName];
      }
    }
    return obj;
  }
}
